import { useEffect, useRef, type RefObject } from 'react';

interface InfiniteScrollSentinelProps {
  onIntersect: () => void;
  enabled: boolean;
  rootRef?: RefObject<HTMLElement | null>;
}

const INTERSECTION_THRESHOLD = 0;

export function InfiniteScrollSentinel({
  onIntersect,
  enabled,
  rootRef,
}: InfiniteScrollSentinelProps) {
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!enabled || !sentinelRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          onIntersect();
        }
      },
      {
        root: rootRef?.current ?? null,
        threshold: INTERSECTION_THRESHOLD,
      }
    );

    observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [enabled, onIntersect, rootRef]);

  return <div ref={sentinelRef} aria-hidden="true" className="h-px w-full" />;
}
